import { Facebook, Instagram, Pinterest, Twitter, YouTube } from "@material-ui/icons"

export const pages_links = [
    {
        id:1,
        label:"Useful links",
        links:[
            {
                id:1,
                label:"Home",
                route:"/",
            },
            {
                id:2,
                label:"About Us",
                route:"/About",
            },
            {
                id:3,
                label:"Pricing",
                route:"/Pricing",
            },
            {
                id:4,
                label:"Blog",
                route:"/blog",
            },
          
        ]

    },
    {
        id:2,
        label:"Betting Markets",
        links:[
            {
                id:1,
                label:'Fixed Matches',
                route:'/fixed-matches'
            },
            {
                id:2,
                label:'VIP Tips',
                route:'/VIP'
            },
            {
                id:3,
                label:'Premium Tips',
                route:'/premium'
            },
            {
                id:4,
                label:'Guru tips',
                route:'/#guru'
            },
        ]
    },
    {
        id:3,
        label:"Multibets",
        links:[
            {
                id:1,
                label:'1X2 Tips',
                route:'/1X2',
            },
            {
                id:2,
                label:'GG/NG Tips',
                route:'/GG-NG',
            },
            {
                id:3,
                label:'OVER/UNDER Tips',
                route:'/ov-und',
            },
            {
                id:4,
                label:'Half/Full Time Tips',
                route:'/htft',
            },
        ]
    },
    {
        id:4,
        label:'Jackpots',
        links:[
            {
                id:1,
                label: "Sportpesa",
                route: '/Sportpesa'
            },
            {
                id:2,
                label: "Betika",
                route: "/Betika",
            },
            {   
                id:3,
                label: "BetPawa",
                route: "/BetPawa"
            },
            {
                id:4,
                label: "SportyBet",
                route: "/SportyBet"
            },
            {
                id:7,
                label: "BongoBongo",
                route: "/BongoBongo"
            },
            {
                id:6,
                label: "Mozzart",
                route: "/Mozzart"
            },
        
        ]
    }
    
]

export const icons =[
    {
        id:1,
        icon:<Facebook/>,
        route:"https://www.facebook.com/Tips-Predictionscom-105570238598662/"
    },
    {
        id:2,
        icon:<Twitter/>,
        route:"https://twitter.com/PredictionsCom"
    },
    {
        id:3,
        icon:<Instagram/>,
        route:"https://www.instagram.com/tipspredictions/"
    },
    {
        id:6,
        icon:<YouTube/>,
        route:"https://www.youtube.com/channel/UCyZe8QtdemTlNcAgYjkkWaA/featured"
    },
    {
        id:5,
        icon:<Pinterest/>,
        route:"https://www.pinterest.com/bettcare/_saved/"
    },
]
